/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SuspendedInfoContainer_settings = {
    readonly organization: {
        readonly name: string;
    };
    readonly " $refType": "SuspendedInfoContainer_settings";
};
export type SuspendedInfoContainer_settings$data = SuspendedInfoContainer_settings;
export type SuspendedInfoContainer_settings$key = {
    readonly " $data"?: SuspendedInfoContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspendedInfoContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuspendedInfoContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '71f5a9b71c9e3f4c1cffc1b469913be5';
export default node;
